module.exports = __webpack_public_path__ + "static/media/6.edd3b70e.png";